import { ImageWrapper } from '../../pages/Login/styledComponents';

export const Logo = () => (
	<ImageWrapper>
		<img
			src="/images/logos/IlluminateLogoMain.png"
			alt="Logo"
			style={{
				height: 'auto',
				width: '100%',
			}}
		/>
	</ImageWrapper>
);
